//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import aes from '@/assets/js/secret.js'
import { registerSms, codeLogin } from '@/api/login.js'
import { getInfo } from '@/api/my'
import { phoneVer } from '../../assets/js/verificat'

export default {
  data () {
    return {
      checked: false,
      title: '登录',
      isLogin: false,
      disabled: false,
      isCheck: false,
      name: '',
      phoneNum: '',
      password: '',
      code: '',
      isAgree: false,
      second: 60,
      showText: true,
    }
  },
  methods: {
    back () {
      this.$router.goBack()
    },
    // 获取登录验证码
    getCode: (function () {
      if (this.phoneNum === '') {
        this.$toast('请输入手机号')
        return
      }
      if (!phoneVer(this.phoneNum)) {
        this.$toast('手机号格式不正确')
        return
      }
      let _this = this
      registerSms({
        aesPhone: aes.encrypt(JSON.stringify({
          time: new Date().getTime(),
          phone: this.phoneNum
        }))
      }).then(res => {
        console.log(res)
        _this.$toast(res.message)
        _this.showText = false
        var interval = setInterval(() => {
          let times = --_this.second
          _this.second = times < 10 ? '0' + times : times // 小于10秒补 0
        }, 1000)
        setTimeout(() => {
          clearInterval(interval)
          _this.second = 60
          _this.showText = true
        }, 60000)
      })
        .catch(err => {
          console.log(err)
        })
    }),
    goLogin () {
      this.$router.replace({
        path: '/login'
      })
    },
    getUuid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    // 登录
    login () {
      if (!this.phoneNum) {
        this.$toast('请输入手机号')
        return
      }
      if (!this.code) {
        this.$toast('请输入验证码')
        return
      }
      if (!this.isAgree) {
        this.isCheck = true
        setTimeout(() => {
          this.isCheck = false
        }, 1000)
        return
      }
      this.isLogin = true
      this.smsLogin()
    },
    // 验证码登录
    smsLogin () {
      this.$toast.loading({
        duration: 1000, // 持续展示 toast
        forbidClick: true,
        loadingType: 'spinner'
      })
      let formData = new FormData()
      let inviteCode = localStorage.getItem('inviteCode') || ''
      formData.append('phone', this.phoneNum)
      formData.append('authCode', this.code)
      if (inviteCode) {
        formData.append('inviteCode', inviteCode)
      }
      localStorage.setItem('uuid', this.getUuid())
      codeLogin(formData)
        .then(res => {
          if (res.code === 200) {
            localStorage.setItem('token', res.data.token)
            if (inviteCode) {
              localStorage.removeItem('inviteCode')
            }
            this.getUser()
            this.$router.push({
              name: 'home'
            })
          }
        }).catch(v => {
          this.$toast(v.message)
        })
    },
    getUser () {
      getInfo().then(res => {
        if (res.data) {
          localStorage.setItem('userInfo', JSON.stringify(res.data))
        }
      })
    },
    agreement () {
      console.log('用户协议')
      this.$router.push({
        path: '/userAgreement'
      })
    },
    privacy () {
      console.log('隐私政策')
      this.$router.push({
        path: '/privacy'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Login/login-model.vue